module.exports = require("@googlemaps/react-wrapper");